import { createSlice } from '@reduxjs/toolkit';
import { AssetTrackingState } from './assetTrackingTypes';
import { 
  addTrackingRecord, 
  updateTrackingRecord, 
  updateTrackingStatus, 
  fetchTrackingRecords, 
  fetchTrackingByAssetId, 
  deleteTrackingRecord 
} from './assetTrackingActions';

const initialState: AssetTrackingState = {
  trackingRecords: [],
  selectedTrackingRecord: undefined,
  loading: false,
  error: undefined,
};

const assetTrackingSlice = createSlice({
  name: 'assetTracking',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Add Tracking Record
      .addCase(addTrackingRecord.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(addTrackingRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.trackingRecords.push(action.payload);
      })
      .addCase(addTrackingRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Tracking Record
      .addCase(updateTrackingRecord.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateTrackingRecord.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.trackingRecords.findIndex(record => record.id === action.payload.id);
        if (index !== -1) {
          state.trackingRecords[index] = action.payload;
        }
      })
      .addCase(updateTrackingRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Tracking Status
      .addCase(updateTrackingStatus.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateTrackingStatus.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.trackingRecords.findIndex(record => record.id === action.payload.id);
        if (index !== -1) {
          state.trackingRecords[index] = action.payload;
        }
      })
      .addCase(updateTrackingStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Tracking Records
      .addCase(fetchTrackingRecords.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTrackingRecords.fulfilled, (state, action) => {
        state.loading = false;
        state.trackingRecords = action.payload;
      })
      .addCase(fetchTrackingRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Tracking Records by Asset ID
      .addCase(fetchTrackingByAssetId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTrackingByAssetId.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTrackingRecord = action.payload;
      })
      .addCase(fetchTrackingByAssetId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Tracking Record
      .addCase(deleteTrackingRecord.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteTrackingRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.trackingRecords = state.trackingRecords.filter(record => record.id !== action.payload.id);
      })
      .addCase(deleteTrackingRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default assetTrackingSlice.reducer;
